import { Button, Result } from 'antd';
import { ROUTES } from './common/constants';
import useRouter from './hooks/useRouter';

const Error404 = () => {
  const { navigate } = useRouter();
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={() => navigate(ROUTES.MAIN)}>
          Back Home
        </Button>
      }
    />
  );
};

export default Error404;
